import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-robotics',
  templateUrl: './robotics.component.html',
  styleUrls: ['./robotics.component.scss']
})
export class RoboticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
